module.exports = __webpack_public_path__ + "img/performance-work-icon6.24f6aeaf.png";